export default __webpack_public_path__ + "1a52b955be7406c955f891cad63535b1.otf";